import {mapActions} from 'vuex';
import fileSaveHelper from '@/lib/file-save-helper';

export default {
  data() {
    return {
      percentage: 0,
      isThumbnailBlobReady: false,
      isAttachmentReady: false,
      statusValue: null,
      statusDesc: null,
      isSending: false,
      isReceiving: false
    };
  },

  computed: {
    isFailed() {
      return this.statusValue === 'RecevingFailed' || this.statusValue === 'SendingFailed';
    },

    isFinished() {
      switch (this.statusValue) {
        case 'RecevingFailed':
        case 'SendingFailed':
        case 'Received':
        case 'Sent':
        case 'NotExist':
          return true;

        default:
          return false;
      }
    }
  },

  beforeDestroy() {
    clearInterval(this._interval);
  },

  methods: {
    ...mapActions('chat', {
      retriveThumbnailStatus: 'retriveThumbnailStatus',
      retriveAttachmentStatus: 'retriveAttachmentStatus'
    }),

    ...mapActions('whiteboard', {
      addBoard: 'addBoard'
    }),

    ...mapActions('alert', {
      addAlert: 'add'
    }),

    reset() {
      this.percentage = 0;
      this.isThumbnailBlobReady = false;
      this.isAttachmentReady = false;
      this.statusValue = null;
      this.statusDesc = null;
      this.isSending = false;
      this.isReceiving = false;
      clearInterval(this._interval);
    },

    async retriveThumbnail(chatMessageDto) {
      let hasThumbnail = await chatMessageDto.HasThumbnailAsync();
      if (hasThumbnail === true) {
        this.isThumbnailBlobReady = true;
      } else {
        // retrieve only download status (for upload case, it will not get here).
        await this.retriveThumbnailStatus({
          chatMessageDto: chatMessageDto,
          callback: this.onStatusResponse.bind(this)
        });
      }
    },

    async retriveAttachment(chatMessageDto) {
      let hasAttachment = await chatMessageDto.HasAttachmentAsync();
      if (hasAttachment === true) {
        this.isAttachmentReady = true;
      }
      // retrieve upload or download status
      await this.retriveAttachmentStatus({
        chatMessageDto: chatMessageDto,
        callback: this.onStatusResponse.bind(this)
      });
    },

    async saveImage(chatMessageDto) {
      if (!chatMessageDto.IsImage() || !(await chatMessageDto.HasAttachmentAsync())) {
        return;
      }
      let blob = await chatMessageDto.GetAttachmentAsync();
      let ext = blob.type.split('/')[1];
      let filename = chatMessageDto.text + '.' + ext;
      fileSaveHelper.saveBlobFile(blob, filename);
    },

    async addImageToWhiteboard(chatMessageDto) {
      if (!chatMessageDto.IsImage() || !(await chatMessageDto.HasAttachmentAsync())) {
        return;
      }
      let blob = await chatMessageDto.GetAttachmentAsync();
      this.addBoard({blob});
      this.addAlert({level: 'info', content: '圖片已加入白板'});
    },

    // status: ChatMessageAttachmentStatus
    onStatusResponse({status, chatMessageDto, isThumbnail, statusDesc, interval}) {
      if (status instanceof Error) {
        this.statusDesc = '發生錯誤';
        clearInterval(interval);
        return;
      }
      this._interval = interval;
      this.isSending = status.IsSending;
      this.isReceiving = status.IsReceiving;

      this.statusValue = status.Status;
      this.statusDesc = statusDesc;

      switch (this.statusValue) {
        case 'Received':
        case 'RecevingFailed':
        case 'Sent':
        case 'SendingFailed':
        case 'NotExist':
        case 'None':
          clearInterval(interval);
      }

      switch (this.statusValue) {
        case 'Received':
        case 'Sent':
          if (isThumbnail) {
            this.isThumbnailBlobReady = true;
          } else {
            this.isAttachmentReady = true;
          }
          this.percentage = 100;
          break;

        case 'PrepareSend':
        case 'Sending':
        case 'SendingFailed':
        case 'PrepareReceive':
        case 'Receiving':
        case 'RecevingFailed':
          this.percentage = Math.round(status.CurBytes/status.TotalBytes*100) || 0;
          break;
      }
    }
  }
};